export const useIsEmbedded = () => {
  // yes, it's a shame :)
  const isEmbedded = global?.window && window.parent !== window.top;
  return isEmbedded;
};
